import { Card, Grid } from "@mui/material";
import { handleDownloadCsv, handlePrintCsv } from "components/utils/handlers";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { anomaliesActions } from "../../../redux/slice/anomalies.slice";
import { GET_DEVICE_ANOMALIES } from "../../../redux/types/devices.types";
import CustomTitle from "../../shared/CustomTitle";
import MyTable from "../../shared/Tables/MyTable/MyTable";
import MyTableToolbar from "../../shared/Tables/MyTable/MyTableToolbar";
import table from "../../shared/Tables/table.module.scss";
import { ANOMALY_DOWNLOAD_COLS, anomalyColumns } from "./helper";

const Anomalies = () => {
  const [anomaliesSearchTerm, setAnomaliesSearchTerm] = useState("");
  const anomalies = useSelector(anomaliesActions.selectors.getAnomalies)

  const dispatch = useDispatch();

  const { id } = useParams();
  useEffect(() => {
    if (id) {
      const payload = {
        deviceId: id
      }
      dispatch({ type: GET_DEVICE_ANOMALIES, payload })
    }
  }, [dispatch, id]);


  const handleAlertSearch = (term) => {
    setAnomaliesSearchTerm(term);
  };

  const filteredAnomalies = useMemo(() => {
    if (!anomaliesSearchTerm) {
      return [...anomalies].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    }

    const regex = new RegExp(anomaliesSearchTerm, "i");
    return anomalies.filter((alert) =>
      Object.values(alert).some((value) => regex.test(value))
    );
  }, [anomalies, anomaliesSearchTerm]);



  return (
    <div>
      <Grid
        my={"15px"}
        container
        sx={{ justifyContent: { xl: "space-between", md: "center" } }}
        spacing={2}
      ></Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} xl={12} className={table.tableContainer}>
          <CustomTitle title={"Anomalies"} count={filteredAnomalies?.length} />
          <Card>
            <MyTableToolbar
              placeHolder={"Search For Anomalies"}
              onSearch={handleAlertSearch}
              onDownload={() =>
                handleDownloadCsv({ rows: filteredAnomalies, columns: ANOMALY_DOWNLOAD_COLS, name: `Device_Anomalies` })
              }
              onPrint={() => handlePrintCsv({ rows: filteredAnomalies, columns: ANOMALY_DOWNLOAD_COLS })}
              isAlerts={false}
            />
            <MyTable
              checkboxSelection={false}
              columns={anomalyColumns}
              rows={filteredAnomalies}
            />
          </Card>
        </Grid>
      </Grid>
      <br />
    </div>
  );
};

export default Anomalies;
